import { Box, Typography, useTheme } from '@mui/material'
import Summary from 'components/summary/summary'
import { List, ListItem } from 'components/ui'
import { PlaceCategory, useMappedTranslation, usePlaces } from 'hooks'
import { EllipsisStyle } from 'styles/theme/theme'

import { AutomationTagIds } from '../../../../assets/test/test-automation-tag-id'
import IconCar from '../assets/images/car.svg'
import IconEtc from '../assets/images/etc.svg'
import IconHome from '../assets/images/home.svg'
import IconPlace from '../assets/images/place.svg'
import IconSchool from '../assets/images/school.svg'
import IconWork from '../assets/images/work.svg'

const PlaceSummary = () => {
  const t = useMappedTranslation()
  const theme = useTheme()

  const MAX_ITEM = 3

  const { places, isInitializing } = usePlaces(true)

  const PlaceMap = {
    1: { title: 'home', icon: IconHome },
    2: { title: 'work', icon: IconWork },
    3: { title: 'car', icon: IconCar },
    4: { title: 'etc', icon: IconEtc },
    5: { title: 'school', icon: IconSchool }
  }

  const placeCount = places.length

  return (
    <Summary
      pageUrl={'/dashboard/places'}
      isLoading={isInitializing}
      paperSx={{ paddingBottom: '24px !important' }}
      titleIcon={IconPlace}
      title={t('place.title')}
      content={
        placeCount === 0 ? (
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
              pt: { xs: '8px', md: '0' }
            }}
            data-testid={AutomationTagIds['cards.dashboard-places-data']}
          >
            <Typography>{t('place.noContents')}</Typography>
          </Box>
        ) : (
          <Box sx={{ width: '100%' }}>
            <List sx={{ padding: { xs: '14px 0', md: '18px 0' } }}>
              {places.slice(0, MAX_ITEM).map((place, index) => (
                <ListItem
                  key={place.placeKey}
                  index={index}
                  iconItemSx={{
                    width: { xs: '48px', md: '56px' },
                    minWidth: '48px',
                    filter: theme.palette.mode === 'dark' ? 'invert(1)' : null
                  }}
                  icon={PlaceMap[place.category]?.icon}
                  iconSx={{
                    height: { xs: '36px', md: '40px' },
                    width: { xs: '36px', md: '40px' }
                  }}
                  title={
                    <>
                      <Box pb={{ xs: '2px', md: '4px' }}>
                        <Typography
                          sx={{ fontSize: '12px', color: theme.palette.secondary.light, lineHeight: { xs: '16px', md: '14px' } }}
                          noWrap
                        >
                          {place.category === PlaceCategory.ETC || !(place?.category in PlaceMap)
                            ? place?.name
                            : t(`place.category.${PlaceMap[place.category]?.title}`)}
                        </Typography>
                      </Box>
                    </>
                  }
                  titleSx={{ minHeight: 0, ...EllipsisStyle, width: { xs: '254px', md: '264px' } }}
                  description={
                    <>
                      <Box sx={{ minHeight: { xs: '16px', md: '22px' } }}>
                        <Typography sx={{ fontSize: '16px', lineHeight: { xs: '22px', md: '20px' }, fontWeight: 500 }} noWrap>
                          {place.category === PlaceCategory.CAR ? place.bluetooth?.name : place.address}
                        </Typography>
                      </Box>
                    </>
                  }
                  fullWidth={true}
                  dividerSx={{ marginLeft: { xs: '48px', md: '56px' }, marginY: { xs: '16px', md: '18px' } }}
                  stackSx={{ overflow: 'hidden' }}
                />
              ))}
            </List>
            {placeCount > MAX_ITEM && (
              <Box sx={{ mx: { xs: '48px', md: '56px' } }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 600, color: theme.palette.info.main, lineHeight: '20px' }}>
                  + {placeCount - MAX_ITEM} {t('place.more')}
                </Typography>
              </Box>
            )}
          </Box>
        )
      }
    />
  )
}

export default PlaceSummary
